import {Injectable} from "@angular/core";
import {ApiNames} from "../enum/api-names.enum";
import { RestService } from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class ApiCreditLogService{

  constructor(private restService : RestService) {
  }

  getCost(apiName : ApiNames, startDate , endDate){
    return this.restService.send({
      method :"GET",
      url : "api-credit-log/cost",
      query : {
        apiName : apiName,
        startDate : startDate,
        endDate : endDate
      }
    })
  }

}
